import React from 'react';
import { connect, ResolveThunks } from 'react-redux';
import { Button, Dialog, Grid, Stack, Typography } from '@mui/material';

import { startEditingJob } from '../../actions/jobActions';
import { RootState } from '../../store';
import { setShowAlertBox } from '../../store/alertBoxSlice';

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = StateProps & DispatchProps;

class AlertBox extends React.Component<Props> {
  okButton?: HTMLButtonElement | null;

  onOkPressed = () => {
    this.props.setShowAlertBox(false);
  };

  onShare() {
    this.props.startEditingJob(this.props.job!);
    this.props.setShowAlertBox(false);
  }

  render() {
    const shareButton =
      this.props.jobOrganization !== '' ? null : (
        <Grid>
          <Button sx={{ width: 200 }} variant="outlined" onClick={() => this.onShare()}>
            Share
          </Button>
        </Grid>
      );
    const orgText =
      this.props.jobOrganization === '' ? (
        <Typography align="center">
          Only your organization can see this job until you share it with another organization.
        </Typography>
      ) : (
        <Typography align="center">{`Your job has been shared with ${this.props.jobOrganization}.`}</Typography>
      );

    // The extra div with padding is due to https://v4.mui.com/components/grid/#negative-margin and should be able to be
    // removed in MUI v5 according to https://github.com/mui-org/material-ui/issues/7466#issuecomment-820736245.
    return (
      <Dialog open={this.props.show}>
        <div style={{ padding: 8 }}>
          <Stack spacing={2} sx={{ p: 4, justifyContent: 'center', alignItems: 'center' }}>
            <Typography align="center">{`Job ${this.props.id}, ${this.props.name}, is processing and has been added to the grid.`}</Typography>
            {orgText}
            <Grid container spacing={2} sx={{ justifyContent: 'space-evenly', alignItems: 'center' }}>
              <Grid>
                <Button
                  sx={{ width: 200 }}
                  variant="outlined"
                  onClick={this.onOkPressed}
                  ref={(obj) => {
                    this.okButton = obj;
                  }}
                >
                  OK
                </Button>
              </Grid>
              {shareButton}
            </Grid>
          </Stack>
        </div>
      </Dialog>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  id: state.alertBox.id,
  show: state.alertBox.show,
  name: state.alertBox.name,
  jobOrganization: state.alertBox.jobOrganization,
  job: state.alertBox.job,
});

const actionCreators = {
  setShowAlertBox,
  startEditingJob,
};

export default connect(mapStateToProps, actionCreators)(AlertBox);
